// Added by Sejune Oh on 2020-03-31
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, useState, useEffect, CSSProperties } from 'react';

interface LegacyAppIconProps {
  iconName: string
  iconSize: number
  title?: string
  style?:CSSProperties
}

const LegacyAppIcon: FC<LegacyAppIconProps> = ({ iconName, title, iconSize = 0, style,...props}) => {
  const [innerText, setInnerText] = useState('')

  const getIcon = (icon: string) => {
    const [, iconName] = icon.split(':')
    const $element = document.querySelector(`g#${iconName}`)
    setInnerText($element ? $element.innerHTML : '')
  }

  useEffect(() => getIcon(iconName), [iconName])

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ! Render
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ width: iconSize + 'px', height: iconSize + 'px', ...style }} title={title}>
        <svg
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
        style={{pointerEvents: 'none', display: 'block', width: '100%', height: '100%'}}
        >
          <g dangerouslySetInnerHTML={{__html: innerText}} ></g>
        </svg>
      </div>
  </div>
  )
}

export default LegacyAppIcon
